// import './CheckoutPage.less';

export const prefix = 'bm-p-checkout';

export { default } from './CheckoutPage';
